// src/components/ReloadPrompt.tsx
import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import './ReloadPrompt.css';

function ReloadPrompt() {
  // --- Vite PWA Plugin Placeholders ---
  // These are replaced during the build process.
  // We cast them to string to satisfy TypeScript before the build.
  const reloadSW = '__RELOAD_SW__' as string; // Cast to string

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      console.log(`Service Worker registered: ${swUrl}`);
      // Example: Send periodic sync request if needed
      // if (registration?.periodicSync) {
      //   registration.periodicSync.register('content-sync', { minInterval: 24 * 60 * 60 * 1000 });
      // }

      // Send skip waiting message immediately if reloadSW is true and SW is waiting
      // This helps ensure the new SW activates faster with autoUpdate.
      if (reloadSW === 'true' && registration?.waiting) {
        console.log('New SW waiting, sending SKIP_WAITING message.');
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    },
    onRegisterError(error) {
      console.error('Service Worker registration error:', error);
    },
  });

  // Close the prompt
  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  // --- Handle Auto Update ---
  // When `needRefresh` becomes true (and registerType is 'autoUpdate'),
  // the service worker is updated automatically.
  // This effect triggers the actual page reload *after* the SW update.
  useEffect(() => {
    if (needRefresh) {
      console.log('ReloadPrompt: needRefresh is true, calling updateServiceWorker(true).');
      updateServiceWorker(true); // `true` reloads the page
    }
  }, [needRefresh, updateServiceWorker]);

  // --- Render Logic ---
  // Only show the prompt briefly for "Offline ready" or if somehow
  // `needRefresh` becomes true but the auto-update hasn't reloaded yet.
  return (
    <div className={`ReloadPrompt-container ${offlineReady || needRefresh ? 'ReloadPrompt-visible' : ''}`}>
      {(offlineReady || needRefresh) && (
        <div className="ReloadPrompt-toast">
          <div className="ReloadPrompt-message">
            {offlineReady ? (
              <span>App ready to work offline.</span>
            ) : (
              // This message might only flash briefly with autoUpdate
              <span>New version available, reloading...</span>
            )}
          </div>
          {/* Button might still be useful if auto-reload fails or for different registerTypes */}
          {/* {needRefresh && (
            <button className="ReloadPrompt-button" onClick={() => updateServiceWorker(true)}>
              Reload Now
            </button>
          )} */}
          <button className="ReloadPrompt-button ReloadPrompt-close" onClick={close}>
            Close
          </button>
        </div>
      )}
      {/* Optional: Display build date for debugging */}
      {/* <div className="ReloadPrompt-date">Build Date: {buildDate}</div> */}
    </div>
  );
}

export default ReloadPrompt;